import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import type { PrivateLayoutProps } from './index'
import { PrivateLayout } from './index'
import { useUser } from '@ztechapps/common.hook'
import includes from 'lodash/includes'
import { useMemo } from 'react'

export type HasAppAccessPrivateLayoutProps = PrivateLayoutProps & {
  hasAppAccessPermission: string
}

export const HasAppAccessPrivateLayout = ({ hasAppAccessPermission, header, sidebar }: HasAppAccessPrivateLayoutProps) => {
  const { user, isActive, hasTenant, loading, logout } = useUser()

  const roles = user?.roles
  const userId = user?._id
  const hasAppAccess = includes(roles, hasAppAccessPermission)

  const isAuthenticated = useMemo<boolean | null>(() => {
    if (loading) return null

    return !hasAppAccess || !hasTenant || !isActive || !!userId
  }, [loading, hasAppAccess, isActive, hasTenant, userId])

  if (isAuthenticated === null)
    return (
      <CenterScreen>
        <LoadingContent message={`Loading....`} subMessage="Please wait while we are loading the screen..." />
      </CenterScreen>
    )

  if (isAuthenticated === false) {
    logout()
    return null
  }

  //if the user is authenticated can go here
  return <PrivateLayout header={header} sidebar={sidebar} />
}
